import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { AnimatedBackground } from "components/AnimatedBackground";
import { CartoonCardBasic } from "components/CartoonCard";
import Iconify from "components/iconify";
import CenteredFooter from "examples/Footers/CenteredFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import { CA, TICKER, WEB_APP_LINK } from "utils/constants";
import AboutApp from "./sections/AboutApp";
import BestFarts from "./sections/BestFarts";
import Community from "./sections/Commnunity";
import Team from "./sections/Team";
import MKTypography from "components/MKTypography";


function FartLabLanding() {

  const handleScroll = () => {
    const nextSection = document.getElementById("features");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Navbar */}
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "https://jup.ag/swap/SOL-9x4nhMHb46DcCzYkUJ6VaK29YnbCU4wA3VDmJWyCpump",
          label: "Buy " + TICKER,
          color: "primary",
        }}
        transparent
        light
      // sticky
      />

      {/* Main Container */}
      <AnimatedBackground>
        {/* Hero Section (100vh) */}
        {/* Hero Section */}
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <CartoonCardBasic
                title="The AI FartLab 🚀💨"
                description="The ultimate AI-powered app for measuring, analyzing, and generating hilarious farts!"
                color="#ff4e50"
                tilt
                // endTiltAngle={3}
                buttons={[
                  {
                    label: "Coming Soon",
                    icon: "mdi:google-play",
                    onClick: () => alert("Coming Soon to Play Store!"),
                    disabled: true,
                    color: "white",
                  },
                  {
                    label: "Coming Soon",
                    icon: "mdi:apple",
                    onClick: () => alert("Coming Soon to Apple Store!"),
                    disabled: true,
                    color: "white",
                  },
                  {
                    label: "Web App",
                    icon: "mdi:web",
                    onClick: () => window.open(WEB_APP_LINK, "_blank"),
                    color: "white",
                  },
                ]}
              >
                {CA && CA.length > 0 && (
                  <MKTypography
                    variant="h4"
                    color="white"
                    sx={{
                      textShadow: "2px 2px black",
                      letterSpacing: "2px",
                      whiteSpace: "pre-line",
                      mt: 2,
                    }}
                  >
                    CA: {CA}
                  </MKTypography>
                )}
              </CartoonCardBasic>
            </Grid>
          </Container>

          {/* Scroll Down Button */}
          <Box
            onClick={handleScroll}
            sx={{
              position: "absolute",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              cursor: "pointer",
              padding: "12px",
              borderRadius: "50%",
              backgroundColor: "#FFD700",
              border: "3px solid black",
              boxShadow: "6px 6px 0px rgba(0,0,0,0.4)",
              transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              animation: "bounce 1.5s infinite ease-in-out",

              "&:hover": {
                transform: "translateX(-50%) scale(1.1)",
                boxShadow: "8px 8px 0px rgba(0,0,0,0.4)",
              },

              "&:active": {
                transform: "translateX(-50%) scale(0.95)",
                boxShadow: "4px 4px 0px rgba(0,0,0,0.4)",
              },
            }}
          >
            <Iconify icon="mdi:arrow-down-bold" width={36} height={36} />
          </Box>
        </Box>
        {/* Divider */}
        {/* <CartoonDivider /> */}
        {/* Features Section */}
        {/* <MKBox id="features" py={10}> */}
        <AboutApp id="features" />
        <BestFarts id="best_farts" />

        {/* <Tokenomics id="tokenomics" /> */}
        {/* <Roadmap id="roadmap" /> */}
        {/* <AboutFlart id="about_app" /> */}
        <Team id="team" />
        <Community id="community" />

        {/* Footer */}
        <CenteredFooter light />
      </AnimatedBackground>
    </>
  );
}

export default FartLabLanding;
